// ============================================================
// printText - send plain text to the printer.
//
// A hidden iframe holding the text in a <pre>, printed and removed: the
// app's own page is a three-panel dark UI that prints as a black
// rectangle, and a pop-up window would be blocked.
// ============================================================

const PAGE_STYLE = 'body{margin:16mm;font:11pt/1.4 Georgia,serif;color:#000}pre{white-space:pre-wrap;font:inherit}';

/** Print `text` under `title`. Returns false when the browser gives no frame to print from. */
export default function printText(title: string, text: string): boolean {
  const frame = document.createElement('iframe');
  frame.setAttribute('aria-hidden', 'true');
  frame.style.position = 'fixed';
  frame.style.width = '0';
  frame.style.height = '0';
  frame.style.border = '0';
  document.body.appendChild(frame);
  const doc = frame.contentDocument;
  const view = frame.contentWindow;
  if (!doc || !view) {
    frame.remove();
    return false;
  }
  doc.title = title;
  const style = doc.createElement('style');
  style.textContent = PAGE_STYLE;
  const pre = doc.createElement('pre');
  // As text, never as markup: a character's name or notes may hold anything.
  pre.textContent = text;
  doc.head.appendChild(style);
  doc.body.appendChild(pre);
  view.focus();
  view.print();
  // After the print dialog has taken its copy.
  setTimeout(() => frame.remove(), 1000);
  return true;
}
